/* eslint-disable @typescript-eslint/no-explicit-any */
import { removeAfterParagraph } from './OfferUtils';
export const constructJsonSchema = (data: any, item: any) => {
  if (data) {
    const headerListItems = data;
    const richTextItems = item;
    const faqsArray: any = headerListItems?.map((headerItem: any) => {
      const nodeName = headerItem?.nodeName ?? '';
      const name = headerItem?.header ?? '';
      const specificCard = richTextItems?.[nodeName] ?? {};
      const text = specificCard?.[':items']?.richtext?.text ?? specificCard?.[':items']?.text?.descriptionText ?? '';
      // Using removeAfterParagraph to clean the text recieved from RTE
      const nameRTEText = removeAfterParagraph(name);
      const textRTE = removeAfterParagraph(text);
      return {
        '@type': 'Question',
        name: nameRTEText,
        acceptedAnswer: {
          '@type': 'Answer',
          text: textRTE,
        },
      };
    });

    const jsonObject = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqsArray,
    };

    return jsonObject;
  }
  return;
};
